module.exports = __webpack_public_path__ + "static/media/ResponPic2.b9497cda.jpg";